import {NOTHING_SELECTED_MEDIA, SET_FABRIC_TEMPLATE, SET_TEMPLATE_SNAPSHOT} from './constants';
import {SET_ALL_ASSETS} from '~/CreateFabricInvitation/reducers/constants';
import {INIT_APP} from '~/common/fabric/constants';
import {fabricArtWithHttpsForAllImgPaths} from '~/common/utils/event_utils';

const initialState = {
  artist: '',
  backgroundColor: '',
  backgrounds: [],
  overlays: [],
  displayName: '',
  editableArt: {default: []},
  envelopes: [],
  eventType: '',
  liners: [],
  metaDescription: null,
  premium: false,
  snapshot: null,
  stamps: [],
  stickers: [],
  quickInvite: false,
  templateName: '',
  allBackgrounds: [],
  allOverlays: [],
  allReveals: [],
  allEnvelopes: [],
  allLiners: [],
  allStamps: [],
  allStickers: [],
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FABRIC_TEMPLATE:
      return {...state, ...action.payload};
    case SET_TEMPLATE_SNAPSHOT:
      return {...state, snapshot: action.payload};
    case INIT_APP: {
      const {template} = action.payload;
      return {
        allBackgrounds: action.payload.allBackgrounds || initialState.allBackgrounds,
        allOverlays: action.payload.allOverlays || initialState.allOverlays,
        allReveals: action.payload.allReveals || initialState.allReveals,
        allEnvelopes: action.payload.allEnvelopes || initialState.allEnvelopes,
        allLiners: action.payload.allLiners || initialState.allLiners,
        allStamps: action.payload.allStamps || initialState.allStamps,
        allStickers: action.payload.allStickers || initialState.allStickers,
        backgrounds: action.payload.allBackgrounds || initialState.allBackgrounds,
        artist: template.artist,
        backgroundColor: template.background_color,
        displayName: template.display_name,
        editableArt: fabricArtWithHttpsForAllImgPaths(template.editable_art),
        envelopes: template.envelopes,
        eventType: template.event_type,
        liners: template.liners,
        metaDescription: template.meta_description,
        premium: template.premium,
        rsvpOptional: template.rsvp_optional,
        snapshot: null,
        stamps: action.payload.stamps,
        stickers: template.stickers,
        templateName: template.id,
        usedAs: template.used_as,
        quickInvite: template.quick_invite,
      };
    }
    case SET_ALL_ASSETS: {
      const {
        allStamps,
        allStickers,
        allLiners,
        allBackgrounds,
        allEnvelopes,
        allOverlays,
        allReveals,
      } = action.payload.allAssets;

      return {
        ...state,
        ...{
          allStamps,
          allStickers,
          allLiners,
          allBackgrounds,
          allEnvelopes,
          backgrounds: allBackgrounds,
          stamps: allStamps,
          allOverlays: [NOTHING_SELECTED_MEDIA, ...allOverlays],
          allReveals: [NOTHING_SELECTED_MEDIA, ...allReveals],
        },
      };
    }
    default:
      return state;
  }
};
